import { render, staticRenderFns } from "./SpimCategories.vue?vue&type=template&id=b885c0ce&"
import script from "./SpimCategories.vue?vue&type=script&lang=js&"
export * from "./SpimCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports